import get from 'lodash/get';
import { statuses } from '../VisitsAvailabilitySingle/util';

const { OPEN, PARTIALLY_OPEN, FULL } = statuses;

const BLOCKED = {
  NO_SCHOOL: statuses.BLOCKED_NO_SCHOOL,
  HOLIDAY: statuses.BLOCKED_HOLIDAY,
  SCHOOL_EVENT: statuses.BLOCKED_SCHOOL_EVENT,
  OUTSIDE_AVAILABILITY: statuses.BLOCKED_OUTSIDE_AVAILABILITY_WINDOW,
  OTHER: statuses.BLOCKED_OTHER,
};
export const NO_AVAILABILITY = 'NO_AVAILABILITY';

export function arrangeAppointmentsByDay(week, availabilitySlots) {
  return week.map((columnDate) => {
    if (availabilitySlots) {
      const match = availabilitySlots.find(({ date }) => date === columnDate);
      return {
        id: get(match, 'id'),
        date: columnDate,
        status: get(match, 'status'),
        timezone: get(match, 'timezone'),
        appointments: get(match, 'appointments') || [],
      };
    }
    return undefined;
  });
}

function getMS(isoDate) {
  if (typeof isoDate === 'string') {
    const dateParts = isoDate.split(/[-T:]/);
    dateParts[1] = parseInt(dateParts[1], 10) - 1;
    return (new Date(...dateParts)).getTime();
  } else {
    return (new Date(isoDate)).getTime();
  }
}

export function canRSVP(today, date, deadline = 0) {
  const deadlineTime = new Date(getMS(date));
  deadlineTime.setDate((deadlineTime.getDate() - deadline) + 1);
  return getMS(today) < getMS(deadlineTime);
}

export function isOutsideVisitsWindow(currentDay, firstDay, lastDay) {
  currentDay = getMS(currentDay);
  firstDay = getMS(firstDay);
  lastDay = getMS(lastDay);
  return (currentDay < firstDay) || (currentDay > lastDay);
}

export function isOpen(status) {
  return status === OPEN || status === PARTIALLY_OPEN;
}

export function isFull(status) {
  return status === FULL;
}

export function isBlocked(status) {
  return status === BLOCKED.NO_SCHOOL || status === BLOCKED.OUTSIDE_AVAILABILITY ||
    status === BLOCKED.HOLIDAY || status === BLOCKED.SCHOOL_EVENT || status === BLOCKED.OTHER;
}

function isUnavailable(availability, today, deadline, firstDay, lastDay) {
  return !availability ||
    !availability.status ||
    isFull(availability.status) ||
    !canRSVP(today, availability.date, deadline) ||
    (isOpen(availability.status) && !availability.appointments.length);
}

function allUnavailable(availabilityForWeek, today, deadline, firstDay, lastDay, index, maxIndex) {
  let colSpan = 1;
  if (isUnavailable(availabilityForWeek[index], today, deadline, firstDay, lastDay) && index<maxIndex) {
    colSpan += allUnavailable(availabilityForWeek, today, deadline, firstDay, lastDay, index+1, maxIndex);
  }
  return colSpan;
}

function allOutsideVisitsWindow(availabilityForWeek, firstDay, lastDay, index, maxIndex) {
  let colSpan = 1;
  while (index < maxIndex && isOutsideVisitsWindow(availabilityForWeek[index].date, firstDay, lastDay)) {
    colSpan += 1;
    index += 1;
  }

  return colSpan;
}

function allBlocked(availabilityForWeek, status, index, maxIndex) {
  let colSpan = 1;
  const dayStatus = get(availabilityForWeek[index], 'status');
  if (dayStatus === status && index<maxIndex) {
    colSpan += allBlocked(availabilityForWeek, status, index+1, maxIndex);
  }
  return colSpan;
}

export function createAvailabilityBlocks(availabilityByWeek, today, deadline, firstDay, lastDay, availabilityVisible) {
  const cells = [];

  if (!availabilityVisible) {
    cells.push({ colSpan: availabilityByWeek.length });
    return cells;
  }

  let i = 0;
  let colSpan = 1;
  const maxIndex = availabilityByWeek.length;

  while (i < maxIndex) {
    const availabilityForDay = availabilityByWeek[i];
    const status = get(availabilityForDay, 'status');
    colSpan = 1;

    if (isOutsideVisitsWindow(availabilityForDay.date, firstDay, lastDay)) {
      colSpan = allOutsideVisitsWindow(availabilityByWeek, firstDay, lastDay, i + 1, maxIndex);
      cells.push({ status: BLOCKED.OUTSIDE_AVAILABILITY, colSpan });
      i += colSpan;
    } else if (isBlocked(status)) {
      colSpan = allBlocked(availabilityByWeek, status, i+1, maxIndex);
      cells.push({ status, colSpan });
      i += colSpan;
    } else if (isUnavailable(availabilityForDay, today, deadline, firstDay, lastDay)) {
      colSpan = allUnavailable(availabilityByWeek, today, deadline, firstDay, lastDay, i + 1, maxIndex);
      cells.push({ status: NO_AVAILABILITY, colSpan });
      i += colSpan;
    } else {
      availabilityForDay.colSpan = colSpan;
      cells.push(availabilityForDay);
      i += colSpan;
    }
  }

  return cells;
}

export function parseISODate(isoDate) {
  if (typeof isoDate === 'string') {
    const dateParts = isoDate.split(/[-T:]/);
    dateParts[1] = parseInt(dateParts[1], 10) - 1;
    return new Date(...dateParts);
  } else {
    return new Date(isoDate);
  }
}
